module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.a4d31128b633bc0b1cc1.woff2";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module id = ../../../../../client/assets/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module chunks = styles